import React from "react";

import "./statuscard.css";

const StatusCard = ({ icon, count, title, subtitle, ...rest }) => {
  // const {rest} = props
  console.log("rest", rest);
  const { children } = rest;
  return (
    <div {...rest} className="flex flex-col status-card">
      <div {...rest} style={{minWidth:400, width:'auto'}} className="flex w-full items-center justify-between ">
        <div className="status-card__icon mx-3">
          <i className={icon}></i>
        </div>
        <div className="status-card__info">
          <h4>{count}</h4>
          <span className="flex flex-col justify-center items-center my-2">
            {title}
            {subtitle && (
              <i className="font-extrabold text-xs text-green-600">
                {subtitle}
              </i>
            )}
          </span>
        </div>
      </div>
      <div className="flex w-full flex-col">{children}</div>
    </div>
  );
};

export default StatusCard;
